/**
 * App updates (service worker), shared by both front ends. Each one draws
 * its own "a new version is ready" bar through `onUpdateReady`.
 */
type Listener = (apply: () => void) => void;

const listeners = new Set<Listener>();
let apply: (() => void) | null = null;

export function watchForUpdates(): void {
  if (!("serviceWorker" in navigator) || !import.meta.env.PROD) return;
  import("virtual:pwa-register").then(({ registerSW }) => {
    const update = registerSW({
      onNeedRefresh() {
        apply = () => void update(true);
        for (const fn of listeners) fn(apply);
      },
    });
  });
}

/** Called once a new version has been downloaded and is waiting to take over. */
export function onUpdateReady(fn: Listener): () => void {
  listeners.add(fn);
  if (apply) fn(apply);
  return () => listeners.delete(fn);
}
